<script>
import aclService from '../../../../domain/acl/services/acl'

export default {
  data () {
    return {
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      data: {
        id: null,
        codigo: '',
        nome: '',
        descricao: ''
      }
    }
  },
  mounted () {
    this.start()
  },
  methods: {
    start () {
      if (this.$route.params.id) {
        // Carregar dados da ACL se ID estiver presente
        this.loadAclData(this.$route.params.id)
      } else {
        // Inicializar com dados vazios se nenhum ID estiver presente
        this.data = {
          id: null,
          codigo: '',
          nome: '',
          descricao: ''
        }
        this.isLoaded = true
      }
    },
    loadAclData (id) {
      aclService.get(id)
        .then(response => {
          this.data = response.data
          console.log('Dados da ACL:', this.data)
          this.isLoaded = true
        })
        .catch(error => {
          console.error('Erro ao carregar dados da ACL:', error)
          this.isLoaded = true
        })
    },
    submit () {
      this.cadastroError = null
      this.atualizadoSucesso = false
      if (this.data.id) {
        aclService.update(this.data, this.data.id)
          .then(() => {
            this.atualizadoSucesso = true
          })
          .catch(error => {
            this.cadastroError = error.response.data
          })
      } else {
        aclService.new(this.data)
          .then(() => {
            this.atualizadoSucesso = true
          })
          .catch(error => {
            this.cadastroError = error.response.data
          })

        const data = {
          codigo: this.data.codigo,
          nome: this.data.nome,
          descricao: this.data.descricao
        }

        if (this.data.id) {
          aclService.update(data, this.data.id)
            .then(() => {
              this.atualizadoSucesso = true
            })
            .catch(error => {
              this.cadastroError = error.response.data
            })
        } else {
          aclService.new(data)
            .then(() => {
              this.atualizadoSucesso = true
            })
            .catch(error => {
              this.cadastroError = error.response.data
            })
        }
      }
    },
    printError (err) {
      return Array.isArray(err) ? err[0] : err
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">{{ data.id ? 'Editar' : 'Cadastro' }} de ACL</h1></div>
          <div class="col-sm-6">
            <router-link :to="{ name: 'acls' }" class="pull-right hidden-print" style="clear: left">
              <strong class="label no-radius bg-info">Voltar</strong>
            </router-link>
          </div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{ printError(erro) }}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">Atualizado com sucesso!</div>
            </div>
            <form class="bs-example form-horizontal" @submit.prevent="submit">
              <div class="form-group">
                <label class="col-sm-2 control-label">Nome</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" v-model="data.nome" required />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Código</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" v-model="data.codigo" required />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">Descrição</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" v-model="data.descricao" />
                </div>
              </div>
              <div class="clearfix"></div>
              <hr>
              <div class="row wrapper">
                <u-button  class="btn m-b-xs w-xs btn-info m-r-xs" type="submit">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$router.push({ name: 'acls' })">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Acl.vue?22dc58b7